import { render, staticRenderFns } from "./ListNotasInseridasWeeklyView.vue?vue&type=template&id=705a8816&"
import script from "./ListNotasInseridasWeeklyView.vue?vue&type=script&lang=ts&"
export * from "./ListNotasInseridasWeeklyView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports